var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import TextArea from 'syf-component-library/ui/atoms/Textarea';
import { Small } from 'syf-component-library/ui/typography';
import { clearFormError, updateFormError } from '../../../redux/ui/ui.slice';
import { spacing } from 'syf-component-library/defaultTheme';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { updateUserAnswers } from '../../../redux/userAnswers/userAnswers.slice';
import formatUserAnswer from '../../../helpers/formatUserAnswer';
import getCurrentQuestionAnswer from '../../../helpers/getCurrentQuestionAnswer';
import { t } from '../../../strings/i18n/i18n';
import CHARACTER_LIMIT, { ALLOWED_SPECIAL_CHARS, specialCharacterRegex } from '../../../const/characterValidation';
import styled from 'styled-components';
import useTextareaSizing from '../../../hooks/useTextareaSizing';
import formatNumberWithComma from '../../../helpers/formatNumber';
import Icon from '../Icon';
import SpecialCharacterReminder from '../SpecialCharacterReminder';
var TextAreaWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  width: 100%;\n"], ["\n  display: inline-block;\n  width: 100%;\n"
    /*
     * Temporary solution to overflow issue w/ the clearFormError.
     * TODO: Textarea component in the CL should count the helper text height as part
     * of its dynamic height: https://bitbucket.glb.syfbank.com/projects/EUI/repos/component-library/browse/src/ui/atoms/Textarea/helpers.tsx#16
     */
])));
/*
 * Temporary solution to overflow issue w/ the clearFormError.
 * TODO: Textarea component in the CL should count the helper text height as part
 * of its dynamic height: https://bitbucket.glb.syfbank.com/projects/EUI/repos/component-library/browse/src/ui/atoms/Textarea/helpers.tsx#16
 */
var HiddenText = styled(function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    _jsx(Small, __assign({}, props, { children: children })));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: calc(", "px + 2.5px);\n  margin-bottom: 2.5px;\n  visibility: hidden;\n"], ["\n  margin-top: calc(", "px + 2.5px);\n  margin-bottom: 2.5px;\n  visibility: hidden;\n"])), spacing.xsmall);
var TextBox = function (_a) {
    var _b, _c, _d, _e;
    var answer = _a.answer;
    var dispatch = useDispatch();
    var _f = useSelector(function (state) { return state; }, shallowEqual), formError = _f.ui.formError, userAnswers = _f.userAnswers, currentQuestion = _f.questionnaire.currentQuestion;
    var maxHeight = useTextareaSizing({
        maximumCharacters: CHARACTER_LIMIT
    }).maxHeight;
    var textRef = useRef(null);
    var options = (answer === null || answer === void 0 ? void 0 : answer.answerOptions) || [];
    var nextQuestionId = (_b = options[0]) === null || _b === void 0 ? void 0 : _b.nextQuestionId;
    var answerId = (_c = options[0]) === null || _c === void 0 ? void 0 : _c.answerId;
    var disputeReason = (_d = options[0]) === null || _d === void 0 ? void 0 : _d.disputeReason;
    var script = (_e = options[0]) === null || _e === void 0 ? void 0 : _e.script;
    var placeholder = (answer === null || answer === void 0 ? void 0 : answer.placeHolder) || '';
    var currentQuestionAnswer = getCurrentQuestionAnswer({
        userAnswers: userAnswers,
        currentQuestion: currentQuestion
    });
    var userAnswer = currentQuestionAnswer === null || currentQuestionAnswer === void 0 ? void 0 : currentQuestionAnswer.answers[0];
    var characterCount = (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.length) || 0;
    var charactersRemaining = CHARACTER_LIMIT - characterCount;
    var numberWithComma = formatNumberWithComma(charactersRemaining);
    var characterCountText = charactersRemaining === 1
        ? t('questionnaire.oneCharacterCountHelpText')
        : t('questionnaire.characterCountHelpText', {
            charactersRemaining: numberWithComma
        });
    var reminderText = t('questionnaire.reminder', {
        specialCharacters: ALLOWED_SPECIAL_CHARS
    });
    var handleChange = function (e) {
        var inputValue = e.target.value;
        if (!inputValue || (inputValue === null || inputValue === void 0 ? void 0 : inputValue.trim())) {
            var formattedAnswer = formatUserAnswer({
                nextQuestionId: nextQuestionId,
                answerId: answerId,
                option: [inputValue],
                currentQuestion: currentQuestion,
                disputeReason: disputeReason,
                script: script,
                type: 'TEXTAREA'
            });
            dispatch(clearFormError());
            dispatch(updateUserAnswers(formattedAnswer));
        }
    };
    useEffect(function () {
        if (formError) {
            textRef.current.focus();
        }
    }, [formError]);
    useEffect(function () {
        var disallowedSpecialCharFound = specialCharacterRegex.test(userAnswer);
        if (disallowedSpecialCharFound) {
            dispatch(updateFormError(reminderText));
        }
        else if (characterCount > CHARACTER_LIMIT) {
            var charsOverLimit = characterCount - CHARACTER_LIMIT;
            var errorMessage = charsOverLimit === 1
                ? t('formError.oneCharacterOverLimit')
                : t('formError.charactersOverLimit', {
                    charsOverLimit: charsOverLimit
                });
            dispatch(updateFormError(errorMessage));
        }
        else {
            dispatch(clearFormError());
        }
    }, [characterCount, userAnswer, reminderText, dispatch]);
    return (_jsxs(_Fragment, { children: [_jsxs(TextAreaWrapper, { children: [_jsx(TextArea, { "aria-required": "true", dynamicHeight: true, dynamicHeightMax: maxHeight, error: formError, errorIcon: _jsx(Icon, { name: "falExclamationCircle", size: "sm" }), helpText: characterCountText, id: "syf-text-area", onChange: handleChange, placeholder: placeholder, sizeRatio: 1, textfieldRef: textRef, value: userAnswer, width: "758px" }), formError === reminderText && _jsx(HiddenText, { children: reminderText })] }), formError !== reminderText && (_jsx(SpecialCharacterReminder, __assign({ "data-cy": "special-character-reminder" }, { children: reminderText })))] }));
};
export default TextBox;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map